/**
 * Checkbox-kind of selection which:
 * - forces that if child is selected, parent should also be selected.
 * - forces that if parent selected, children should also be selected
 */
import { getNodeId } from '../store/actionHandlers/common/adapterActions';
import HierarchySelectionBase from './common/HierarchySelectionBase';
export default class LowHierarchySelection extends HierarchySelectionBase {
    toggleNodeSelected(oldTreeState, nodeId, { adapter }) {
        return {
            ...oldTreeState,
            ...(this.nodeIsSelected(oldTreeState, nodeId)
                ? deselectNode(oldTreeState, nodeId, adapter)
                : selectNode(oldTreeState, nodeId, adapter)),
        };
    }
}
function selectNode({ models, parents, children, selectionStatuses: oldSelectionStatuses, selection: oldSelection, }, nodeId, adapter) {
    const selectionStatuses = { ...oldSelectionStatuses };
    selectionStatuses[nodeId] = true;
    let parentId = parents[nodeId];
    while (parentId) {
        selectionStatuses[parentId] = true;
        parentId = parents[parentId];
    }
    const selectChildren = (childNodes = []) => {
        for (const childId of childNodes) {
            selectionStatuses[childId] = true;
            selectChildren(children[childId]);
        }
    };
    selectChildren(children[nodeId]);
    return {
        selectionStatuses,
        selection: collectSelection(selectionStatuses, models, oldSelection, adapter),
    };
}
function deselectNode({ models, children, selectionStatuses: oldSelectionStatuses, selection: oldSelection, }, nodeId, adapter) {
    const selectionStatuses = { ...oldSelectionStatuses };
    deselect(nodeId);
    return {
        selectionStatuses,
        selection: collectSelection(selectionStatuses, models, oldSelection, adapter),
    };
    function deselect(id) {
        delete selectionStatuses[id];
        if (children[id]) {
            for (const childId of children[id]) {
                deselect(childId);
            }
        }
    }
}
function collectSelection(selectionStatuses, models, oldSelection, adapter) {
    const oldSelectionById = oldSelection.reduce((hash, oldNode) => {
        hash[getNodeId(adapter, oldNode)] = oldNode;
        return hash;
    }, {});
    return Object.keys(selectionStatuses)
        .map(id => models[id] || oldSelectionById[id])
        .filter(node => !!node);
}
